// Client-side "preview session" — lets an admin (or a shared deep link / the
// admin Preview Studio iframe) browse the LIVE site AS a persona WITHOUT
// changing any real account or touching the logged-in localStorage session.
// Driven by ?preview=<scenario>[&grade=&premium=1]; persisted in sessionStorage
// (isolated per browsing context, so the iframe/tab is independent of the
// admin's real tab).
const PREVIEW_KEY = "iw_preview_session";

export const PREVIEW_LABELS = {
  guest: "Guest",
  founder_basic: "Founder Basic",
  founder_plus: "Founder Plus",
  founder_family_monthly: "Founder Family Pass (Monthly)",
  founder_family_yearly: "Founder Family Pass (Yearly)",
  founder_vip: "Founder VIP",
  child_explorer: "Explorer (child view)",
};

// Read the active preview from the URL (?preview=…) or sessionStorage.
export function getPreviewFromLocation() {
  try {
    const params = new URLSearchParams(window.location.search);
    const fromUrl = params.get("preview");
    if (fromUrl && PREVIEW_LABELS[fromUrl]) {
      const p = {
        scenario: fromUrl,
        grade: params.get("grade") || "3",
        premium: params.get("premium") === "1" || params.get("premium") === "true",
        note: params.get("note") || "",
      };
      sessionStorage.setItem(PREVIEW_KEY, JSON.stringify(p));
      return p;
    }
    const saved = sessionStorage.getItem(PREVIEW_KEY);
    if (saved) {
      const p = JSON.parse(saved);
      if (p && PREVIEW_LABELS[p.scenario]) return p;
    }
  } catch (_) { /* ignore */ }
  return null;
}

export function clearPreviewSession() {
  try { sessionStorage.removeItem(PREVIEW_KEY); } catch (_) { /* ignore */ }
}

// Build a synthetic user object for a scenario. Mirrors the backend
// preview_scenarios.scenario_fields so client gating matches exactly.
export function buildPreviewUser(scenario, grade, premium) {
  const base = {
    id: `preview-${scenario}`,
    email: "preview@isaiahsworld.com",
    name: PREVIEW_LABELS[scenario] || "Preview",
    preview_session: true,
    preview_scenario: scenario,
    subscription_plan: "",
  };
  switch (scenario) {
    case "guest":
      return { ...base, role: "guest", access_tier: 1, tier_name: "Guest", founder_tier: "", is_premium: false, premium_seat: false, founding_member: false, isDemo: true };
    case "founder_basic":
      return { ...base, role: "parent", access_tier: 1, tier_name: "Founder Basic", founder_tier: "founder_basic", is_premium: false, premium_seat: false, founding_member: true };
    case "founder_plus":
      return { ...base, role: "parent", access_tier: 3, tier_name: "Founder Plus", founder_tier: "founder_individual", is_premium: true, premium_seat: true, founding_member: true };
    case "founder_family_monthly":
      return { ...base, role: "parent", access_tier: 3, tier_name: "Founder Family Pass", founder_tier: "founder_family", is_premium: true, premium_seat: true, founding_member: true };
    case "founder_family_yearly":
      return { ...base, role: "parent", access_tier: 3, tier_name: "Founder Family Pass (Yearly)", founder_tier: "founder_yearly", is_premium: true, premium_seat: true, founding_member: true };
    case "founder_vip":
      return { ...base, role: "parent", access_tier: 3, tier_name: "Founder VIP", founder_tier: "founder_vip", is_premium: true, premium_seat: true, founding_member: true };
    case "child_explorer": {
      const prem = !!premium;
      return { ...base, role: "child_explorer", access_tier: prem ? 3 : 1, tier_name: prem ? "Founder VIP" : "Founder Basic", founder_tier: prem ? "founder_vip" : "founder_basic", is_premium: prem, premium_seat: prem, founding_member: true, grade: grade || "3" };
    }
    default:
      return { ...base, role: "guest", access_tier: 1, is_premium: false };
  }
}
